import { useLocation, useParams } from 'react-router';
import { buildMATExportParams } from './useMATExportParams.utils';

/**
 * Extract current MAT filters and discovery export options from URL search params.
 * Excludes pagination and ordering params.
 */
export function useMATExportParams() {
  const { search } = useLocation();
  const { dpid } = useParams<'dpid'>();
  return buildMATExportParams(search, { dataPoolId: dpid });
}

export default useMATExportParams;
